import { css } from '@emotion/core';
export var map = {
  name: "1e6ma0l",
  styles: "display:flex;align-items:center;justify-content:center;width:100%;height:100%;"
};